<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card>
          <v-layout justify-start wrap pt-6>
            <v-flex xs12 sm6 md6 lg3>
              <v-layout justify-center wrap>
                <v-flex xs3 sm3 md2 lg2 pt-1 pl-md-5 text-center>
                  <v-img src="./../../assets/images/school.svg"></v-img>
                </v-flex>
                <v-flex xs9 sm9 md10 lg10 pl-lg-5 text-left>
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >Student list</span
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6 md6 lg9>
              <v-layout justify-center wrap>
                <v-flex xs3 sm3 md2 lg1 pl-7 pt-1 text-center>
                  <v-img
                    width="25px"
                    src="./../../assets/images/Group 478.svg"
                  ></v-img>
                </v-flex>
                <v-flex xs9 sm9 md8 lg8 text-left>
                  <router-link
                    :to="'/viewStudent'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        color: #797979;
                        font-family: nunitosanssemibold;
                        font-size: 18px;
                      "
                      >Add New Students</span
                    >
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout justify-start wrap>
            <v-flex xs12 sm6 md6 pl-6 text-left pt-6>
              <span style="color: #000000; font-family: nunitosanssemibold"
                >Search Student</span
              >
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md2 pa-2>
                <v-select
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  v-model="standard"
                  label="Standard"
                  :items="standardArray"
                  item-text="standardName"
                  item-value="_id"
                  @change="getSearch()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md2 pa-2>
                <v-select
                  v-model="division"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Division"
                  :items="divisionArray"
                  item-text="divisionName"
                  item-value="_id"
                  @change="getSearch()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md2 pa-2>
                <v-text-field
                  dense
                  style="font-family: nunitosansregular"
                  label="Adm. No."
                  v-model="admissionnumber"
                  @change="getSearch()"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm7 md4 pa-2>
                <v-text-field
                  dense
                  style="font-family: nunitosansregular"
                  label="Name"
                  v-model="name"
                  outlined
                  @change="getSearch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md2 pa-2>
                <v-btn
                  dark
                  @click="getSearch()"
                  style="font-family: nunitosansregular"
                  color="#9B8DFD"
                  >SEARCH</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-layout justify-start wrap py-5 v-if="studentList.length > 0">
            <v-flex
              xs12
              sm6
              md4
              v-for="(item, index) in studentList"
              :key="index"
            >
              <v-card-text>
                <v-layout justify-start wrap>
                  <v-flex xs2 sm2 md2 lg1 pt-2 text-center>
                    <span
                      v-if="currentPage > 1"
                      style="font-family: nunitosanssemibold; color: #9d9d9d"
                      >{{ (currentPage - 1) * count + index + 1 }}</span
                    >
                    <span
                      v-else
                      style="font-family: nunitosanssemibold; color: #9d9d9d"
                      >{{ index + 1 }}</span
                    >
                  </v-flex>
                  <v-flex xs3 sm4 md4 lg3 text-center>
                    <v-avatar style="cursor: pointer" size="40">
                      <v-img :src="mediaURL + item.user.photo" />
                    </v-avatar>
                  </v-flex>
                  <v-flex xs5 sm5 md5 lg5 pt-2>
                    <router-link
                      :to="'/studentDetails/' + item._id"
                      style="text-decoration: none"
                    >
                      <span
                        style="font-family: nunitosansregular; color: #000000"
                        >{{ item.user.name }}</span
                      >
                    </router-link>
                  </v-flex>
                  <v-flex xs1 sm1 md1 lg1 pt-2>
                    <v-dialog v-model="item.delete" max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="15" v-on="on" v-bind="attrs"
                          >mdi-close</v-icon
                        >
                      </template>
                      <v-card>
                        <v-card-title style="font-family: nunitosansregular">
                          Are you sure you want to delete this student?
                        </v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="item.delete = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deleteItem(item)"
                            >OK</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-layout v-else justify-center wrap py-8>
            <v-flex xs12 text-center>
              <span
                style="
                  font-family: nunitosansregular;
                  color: #000000;
                  font-size: 14px;
                "
                >Oops !! No data found..</span
              >
            </v-flex>
          </v-layout>
          <div class="text-center pb-5" v-if="pages>1">
            <v-pagination
              :length="pages"
              :total-visible="7"
              v-model="currentPage"
              color="#9B8DFD"
            ></v-pagination>
            <!-- <v-flex xs12 py-5>
              <span
                style="
                  font-family: nunitosansregular;
                  color: #4e4e4e;
                  font-size: 12px;
                "
                >Four Classes Per Page</span
              >
            </v-flex> -->
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      page: 1,
      currentPage: 1,
      pages: 0,
      count: 36,
      totalData: 0,
      appLoading: false,
      ServerError: false,
      classid: "",
      name: "",
      admissionnumber: "",
      studentList: [],
      classArray: [],
      standard: "",
      division: "",
      standardArray: [],
      divisionArray: [],
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getClass();
    this.getStandard();
    this.getDivision();
  },
  methods: {
    getSearch() {
      this.appLoading = true;
      if (this.currentPage > 1) this.currentPage = 1;
      axios({
        method: "GET",
        url: "/student/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          classid: this.classid,
          admissionnumber: this.admissionnumber,
          name: this.name,
          count: this.count,
          page: this.currentPage,
          standard: this.standard,
          division: this.division,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.studentList = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/student/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          classid: this.classid,
          admissionnumber: this.admissionnumber,
          name: this.name,
          count: this.count,
          page: this.currentPage,
          standard: this.standard,
          division: this.division,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.studentList = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.standardArray = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getDivision() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/division/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.divisionArray = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getClass() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var temp = [
            {
              name: null,
              value: null,
            },
          ];
          temp = response.data.data;
          for (var i = 0; i < temp.length; i++) {
            temp[i].name = temp[i].className;
            temp[i].value = temp[i]._id;
          }
          this.classArray = temp;
          this.classArray.unshift({ name: "All", value: null });
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r._id;
      axios({
        url: "/student/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>